<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Updating</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div id="admin-preloader" v-if="loading2">
      <div id="admin-loader-text">Deleting</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <div class="m-auto text-right pt-3">
        <router-link
          :to="{ name: 'offers' }"
          class="text-white"
          style="text-decoration: none"
          ><el-button type="primary" size="medium">
            <i class="el-icon-plus mr-2"></i>Add Offer</el-button
          ></router-link
        >
      </div>
      <b-container class="col-lg-10 mt-5">
        <h3 class="text-info text-center pt-4 my-4">All Offers</h3>
        <!-- User Interface controls -->
        <!-- <b-row>
      <b-col sm="4" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="5" class="my-1">
        <b-form-group  label="" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">Sort By</option>
            </b-form-select>
            <b-form-select :disabled="!sortBy" v-model="sortDesc" slot="append">
              <option :value="false">Asc</option>
              <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
     
      <b-col sm="3" class="my-1">
        <b-form-group horizontal class="mb-0">
          <b-form-select v-model="perPage">
            <option disabled>per page</option>
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="40">40</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row> -->

        <!-- Main table element -->
        <b-table
          show-empty
          stacked="sm"
          :items="items"
          :fields="fields"
          :hover="true"
          head-variant="dark"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :empty-text="emptyText"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          class="mt-4"
        >
          <template slot="index" slot-scope="data">
            {{ data.index + 1 }}
          </template>

          <template slot="id" slot-scope="row">
            <div>{{ row.value }}</div>
          </template>

          <template slot="actions" slot-scope="row">
            <div class="btn-group" role="group" aria-label="Basic example">
              <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

              <a
                size="sm"
                @click.stop="row.toggleDetails"
                class="btn btn-sm btn-info text-white"
              >
                View
              </a>
              <a
                size="sm"
                @click="open(row.item.id)"
                class="btn btn-sm btn-danger text-white"
              >
                Delete
              </a>
            </div>
          </template>

          <template slot="row-details" slot-scope="row">
            <b-card>
              <ul>
                <!-- <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li> -->
                <!-- <template class="" v-for="(item, key) in row.item" >
              <div :key="key"> -->
                <h5 class="text-center text-info">Offer Details</h5>
                <div class="col-6 col-sm-4 col-lg-4" style="">
                  <img class="card-img-top" :src="row.item.image" alt="image" />
                </div>
                <li class="my-3 mr-2">
                  Discount: <span class="ml-2">{{ row.item.dis }}</span>
                </li>
                <li class="my-3 mr-2">
                  Description: <span class="ml-2">{{ row.item.desc }}</span>
                </li>
                <!-- </div>
            </template> -->
              </ul>
              <!-- <h5 class="text-center text-info  my-4">Ordeded Items</h5>
          <div class="row">
            
          <template class="" v-for="(item, key) in row.item.products" >
          <div class="col-6 col-sm-4 col-lg-3" style="" :key="key">
            <img class="card-img-top" :src="item.image" alt="image">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">{{item.name}}</li>
              <li class="list-group-item"><span>Rs</span> {{item.price}}</li>
              <li class="list-group-item"><span>Quantity</span> {{item.quantity}}</li>
              <li class="list-group-item"><span>Total Rs</span> {{item.subTotal}}</li>
            </ul>
          </div>
          </template>
          </div> -->
            </b-card>
          </template>
        </b-table>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
        <!-- Info modal -->
        <!-- <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <pre>{{ modalInfo.content }}</pre>
       <AddProduct/>
    </b-modal> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from "firebase/app";
const items = [];
export default {
  name: "alloffers",
  data() {
    return {
      emptyText: "Loading Records...",
      items: [],
      fields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        // { key: 'id', label: 'Offer ID', sortable: true },
        { key: "dis", label: "Discount (%)", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      productId: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isLoggedIn: false,
      currentUser: false,
      modalInfo: { title: "", content: "" },
      loading: false,
      loading1: false,
      loading2: false,
      changed: true,
      shops: [],
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    open(id) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.deleteOffer(id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    deleteOffer(id) {
      this.loading2 = true;
      this.changed = false;
      this.$store.state.secondaryDatabase
        .collection("offers")
        .doc(id)
        .delete()
        .then(() => {
          //console.log('item deleted', id)
          var newitems = this.items.filter((item) => {
            //console.log('filfkkk')
            return item.id !== id;
          });
          this.items = newitems;
          this.loading2 = false;
          this.changed = true;
          if (this.items.length == 0) {
            this.emptyText = "There are no records to show";
          }
          //console.log(this.items)
          this.shops[0].curOffers -= 1;
          this.$store.state.secondaryDatabase
            .collection("shops")
            .doc(this.shops[0].id)
            .update({
              curOffers: this.shops[0].curOffers,
            })
            .then((doc) => {
              //console.log('doc is', doc)
            })
            .catch((error) => alert(error));
        })
        .catch((error) => alert(error));
    },

    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getId(item) {
      //console.log('getId fun invoked')
      this.productId = item.id;
      //console.log(this.productId)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    backToTop: function () {
      $("html,body").stop().animate(
        {
          scrollTop: 0,
        },
        "fast",
        "swing"
      );
    },
  },
  created() {
    //  if(firebase.auth().currentUser) {
    //       this.isLoggedIn = true;
    //       this.currentUser = firebase.auth().currentUser.email;
    //   }
    this.backToTop();
    this.loading1 = true;
    this.changed = false;
    this.$store.state.secondaryDatabase
      .collection("offers")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            image: doc.data().img,
            dis: doc.data().dis,
            desc: doc.data().desc,
          };
          this.items.push(data);
        });
        if (this.items.length == 0) {
          this.emptyText = "There are no records to show";
        }
        this.loading1 = false;
        this.changed = true;
      });
    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            curOffers: doc.data().curOffers,
          };
          this.shops.push(data);
        });
      });
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
</style>




// WEBPACK FOOTER //
// src/components/admin/AllOffers.vue